import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from 'react-router-dom';
import { AdaptiveLogo } from '../components/ui/AdaptiveLogo';

export const TrainSoundworld = () => {
    const { isAuthenticated, isLoading } = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated && !isLoading) {
            navigate('/');
            return;
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return null;
    }

    return (
        <div className="flex items-center flex-col gap-6 justify-center text-card-foreground h-full">
            <AdaptiveLogo width={ 64 } height={ 64 } />
            <p className="text-2xl font-bold text-card-foreground">Coming Soon!</p>
            <p className="text-base text-muted-foreground max-w-[400px] text-center">
                If you would like to train your own models, please drop us a line here <a href="mailto:ilya@delphos.ai" className="underline">ilya@delphos.ai</a>
            </p>
        </div>
    );
};